import React, {
  createContext,
  useContext,
  useRef,
  useState,
  useEffect,
} from "react";
import { useTimeout, useMeasure } from "react-use";

import { UploadHtml, DownloadPdf } from "../services";

/**
 * The React Context object for pdf exporting
 */
const PdfContext = createContext({});

/**
 * Convenience hook for exporting the current page to PDF
 */
const usePdfExport = () => useContext(PdfContext);

/**
 * Provides user data to the component hierarchy to which it is applied, and
 * encapsulates API service call logic.
 */
function PdfExportProvider({ children }) {
  const [isReady, , reset] = useTimeout(50); //Removed unused 2nd argument (cancel)
  const [ref, { width }] = useMeasure();
  const [isExporting, setIsExporting] = useState(false);
  const [isReadyToExport, setIsReadyToExport] = useState(false);
  const [exportId, setExportId] = useState(null);

  const pdfExportRef = useRef(null);
  const exportPdf = () => {
    reset();
    setIsExporting(true);
  };
  const doneExporting = () => {
    // lexis provides its own mechanism for initiating the download
    if (window.location.href.indexOf("litigationanalytics") < 0) {
      DownloadPdf.get(exportId);
    }
    setExportId(null);
    setIsExporting(false);
  };
  const widthGoal = 870;
  const style = isExporting ? { width: `${widthGoal}px` } : {};
  const className = isExporting ? "is-exporting" : null;
  let ready = isReady();
  useEffect(() => {
    if (width >= widthGoal - 50 && width < widthGoal + 50 && ready) {
      setIsReadyToExport(true);
    }
  }, [width, ready]);
  useEffect(() => {
    if (isExporting && isReadyToExport) {
      UploadHtml.post(pdfExportRef.current.innerHTML).then(({ export_id }) => {
        setIsExporting(false);
        setIsReadyToExport(false);
        setExportId(export_id);
        if (window.location.href.indexOf("litigationanalytics") < 0) {
          console.log("export_id: " + export_id);
        }
      });
    }
  }, [isExporting, isReadyToExport]);
  return (
    <PdfContext.Provider
      value={{ exportPdf, exportId, doneExporting, isReadyToExport }}
    >
      {isExporting && (
        <div
          id="exportCover"
          style={{
            position: "fixed",
            padding: 0,
            margin: 0,
            zIndex: 10,

            top: 0,
            left: 0,

            width: "100%",
            height: "100%",
            background: "rgba(255,255,255,0.9)",
          }}
        >
          <h1>Exporting...</h1>
        </div>
      )}

      <div ref={pdfExportRef} style={style} className={className}>
        {children}
        <div ref={ref}></div>
      </div>
    </PdfContext.Provider>
  );
}

export { PdfExportProvider, usePdfExport };
